import { useFetch } from "../../../public/auth/infrastructure/store/fetch-context";
import {
  LoggedUserT,
  SingleAttr,
  StatusErrorResponse,
  UpdateUserPayload,
} from "../../domain/entities";
import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

const userKeys = {
  user: ["user-me"] as const,
};

const LOGGED_USER_ENDPOINT = "/users/me";

const useGetUserInfo = (): UseQueryResult<LoggedUserT> => {
  const fetch = useFetch();

  return useQuery<LoggedUserT>(userKeys.user, async () => {
    const response = await fetch.get<SingleAttr<LoggedUserT>>(
      LOGGED_USER_ENDPOINT
    );

    return response?.data?.data;
  });
};

const useUpdateUserInfo = (): UseMutationResult<
  LoggedUserT,
  StatusErrorResponse,
  UpdateUserPayload
> => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation<LoggedUserT, StatusErrorResponse, UpdateUserPayload>(
    async (payload) =>
      (
        await fetch.patch<SingleAttr<LoggedUserT>>(
          LOGGED_USER_ENDPOINT,
          payload
        )
      ).data?.data,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(userKeys.user);
      },
    }
  );
};

export { useGetUserInfo, useUpdateUserInfo };
